import { render } from "./systemParameters.vue?vue&type=template&id=16f5ba5f&scoped=true"
import script from "./systemParameters.vue?vue&type=script&lang=js"
export * from "./systemParameters.vue?vue&type=script&lang=js"

import "./systemParameters.vue?vue&type=style&index=0&id=16f5ba5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f5ba5f"]])

export default __exports__